export const invoiceSubscriptionTypes = {
  UNPAID: 'unpaid',
};
